import type { Nullable } from '@clearverify/types';

import type { AddressFieldsFormValues } from 'src/constants/address';

export enum PersonalInformationFormFields {
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  workEmail = 'workEmail',
  timezone = 'timezone',
  birthDate = 'birthDate',
  title = 'title',
  phoneNumber = 'phoneNumber',
  homeAddress = 'homeAddress',
}

export type PersonalInformationFormValues = {
  [PersonalInformationFormFields.firstName]: Nullable<string>;
  [PersonalInformationFormFields.lastName]: Nullable<string>;
  [PersonalInformationFormFields.email]: Nullable<string>;
  [PersonalInformationFormFields.timezone]: Nullable<string>;
  [PersonalInformationFormFields.birthDate]: Nullable<string>;
  [PersonalInformationFormFields.workEmail]: Nullable<string>;
  [PersonalInformationFormFields.title]: Nullable<string>;
  [PersonalInformationFormFields.phoneNumber]: Nullable<string>;
  [PersonalInformationFormFields.homeAddress]: AddressFieldsFormValues;
};
